import React from 'react';
import { NavLink } from 'react-router-dom';
import './SubLinks.css';

function LeadershipLinks() {
  return (
    <div className='links'>
        <ul className='breadcrumbs'>
        <li>
        <NavLink to='/about/leadership/' className='breadcrumb'><i className='fa fa-angle-left'></i> Leadership</NavLink>
        </li> 
        </ul>

      <ul className='sub-items'>

        <li className='sublink-header'>Elders</li>
        <li>
        <NavLink to='/about/leadership/larry-loden' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Larry Loden</NavLink>
        </li> 
        <li>
        <NavLink to='/about/leadership/dave-wolfe' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Dave Wolfe</NavLink>
        </li>
        <li>
        <NavLink to='/about/leadership/micah-monfrini' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Micah Monfrini</NavLink>
        </li>
                <li>
        <NavLink to='/about/leadership/dan-voss' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Dan Voss</NavLink>
        </li>
        </ul>
        <ul className='sub-items'>

<li className='sublink-header'>Pastoral Staff</li>
<li>
<NavLink to='/about/leadership/darrell-hayslip' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Darrell Hayslip</NavLink>
</li> 
<li>
<NavLink to='/about/leadership/will-sanderson' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Will Sanderson</NavLink>
</li> 
</ul>
    </div>
  )
}

export default LeadershipLinks
